import CommonUtils from '@/common-utils';
import routes from './routes.common';

const result = (routes as any).concat([
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/biz-global/login/Login.vue')
  },
]);

result[0].children = result[0].children.concat([
  {
    path: '/login/find-password/confirm', // 비밀번호 찾기 아이디 확인
    name: 'FindPasswordConfirm',
    props: true,
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-global/login/FindPasswordConfirm.vue'),
  },
  {
    path: '/login/find-password/retype', // 비밀번호 찾기 재설정
    name: 'FindPasswordRetype',
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-global/login/FindPasswordRetype.vue'),
  },
  {
    path: '/mypage/member-info', // 회원 정보
    name: 'MemberInfo',
    meta: { auth: true },
    component: () => import(/* webpackChunkName: "kr" */  '../views/biz-global/mypage/MemberInfo.vue'),
  },
  {
    path: '/join', // 회원가입
    name: 'Join', 
    props: true,
    component: () => import(/* webpackChunkName: "others" */  '../views/biz-global/join/Join.vue'),
  },
  {
    path: '/join/complete', // 회원가입>가입완료
    name: 'JoinComplete',
    props: true,
    component: () => import(/* webpackChunkName: "others" */  '../views/biz-global/join/JoinComplete.vue'),
  },  
]);

export default result;
